"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RewardsPoints = RewardsPoints;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _enums = require("./enums");
function RewardsPoints({
  rewardPoints
}) {
  if (typeof rewardPoints !== 'number') {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "user-details-reward-points",
    className: "reward-points"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.proRewardPoints
  }), ": ", rewardPoints);
}
RewardsPoints.propTypes = {
  rewardPoints: _propTypes.default.number
};
var _default = exports.default = RewardsPoints;